/**
 * Capitalize only the first letter of a string.
 *
 * @param {string} str - The input string to capitalize.
 * @returns {string} - The capitalized string.
 *
 * @example
 * capitalizeFirst("wine"); // "Wine"
 * capitalizeFirst("WINE"); // "Wine"
 */
export function capitalizeFirst(str: string): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Pads a number with leading zeros.
 * 
 * @param num - The number to pad
 * @param length - Desired total string length
 * @returns Padded string
 */
export function padNumber(num: number, length: number = 4): string {
  return num.toString().padStart(length, "0");
}

export const capitalizeWords = (text: string): string => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};


export const isNumber = (value: string, includeDecimal: boolean = false): boolean => {
  // if (includeDecimal) {
  //   return /^[0-9]+$/.test(value);
  // } else {
  //   return /^[0-9]+(\.[0-9]+)?$/.test(value);
  // }
  return !isNaN(Number(value))
}